import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=87ac5190&scoped=true&"
import script from "./RowItem.vue?vue&type=script&lang=js&"
export * from "./RowItem.vue?vue&type=script&lang=js&"
import style0 from "./RowItem.vue?vue&type=style&index=0&id=87ac5190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ac5190",
  null
  
)

export default component.exports